/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

export default function Theme({ children }) {
	let theme = createTheme({
		breakpoints: {
			values: {
				xs: 0,
				xsm: 350,
				sm: 600,
				md: 900,
				lg: 1200,
				xl: 1536,
			},
		},
	});

	theme = createTheme(theme, {
		components: {
			MuiOutlinedInput: {
				styleOverrides: {
					root: {
						backgroundColor: '#fff',
						'& .MuiOutlinedInput-notchedOutline & .edit': {
							backgroundColor: '#c9c9c9',
						},
						'& .edit': {},
					},
				},
			},
		},
		typography: {
			h5: {
				[theme.breakpoints.down('xsm')]: {
					fontSize: '1.2rem',
				},
			},
			button: {
				textTransform: 'none',
			},
		},
		palette: {
			primary: {
				main: '#F2A413',
				contrastText: '#FFFFFF',
				dark: '#d99311',
			},
			secondary: {
				main: '#717E8A',
				contrastText: '#FFFFFF',
				dark: '#58626b',
			},
			white: {
				main: '#FFFFFF',
				contrastText: '#000000',
			},
			red: {
				main: '#ff3333',
				contrastText: '#FFFFFF',
			},
		},
	});
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
